
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";







export const useDistriAndDescuentos = () => {

    const { id } = useParams();
    const navigate = useNavigate();


    const handleNavegar = (url) => {
        navigate(`/admin/detalles/${id}/${url}/descuento`);
    }

    const handleNavegarPlanilla = (url) => {
        navigate(`/admin/detalles/${id}/${url}/planilla`);
    }

    const handleNavegarConsumo = () => {
        navigate(`/admin/detalles/${id}/consumo`);
    }


    const handleCrearPlanilla = () => {
        navigate(`/admin/planilla/${id}/create`);
    }



    return {
        handleNavegar,
        handleNavegarPlanilla,
        handleNavegarConsumo,
        handleCrearPlanilla,
    }
}




export const useTotalesDescuento = (consumos, descuentos) => {

    const [consumido, setConsumido] = useState({ consu: 0, sugeri: 0 });
    const [totales, setTotales] = useState({ mortalidad: 0, venta: 0, traslado: 0, descuento: 0 });

    useEffect(() => {
    if (Array.isArray(consumos) && consumos.length > 0) {
        const consu = consumos.reduce((t, a) => t + a.cantidad, 0);
        const sugeri = consumos.reduce((t, a) => t + a.sugerido, 0);
        setConsumido({ consu, sugeri });
    }
    }, [consumos]);



    useEffect(() => {
        if(descuentos?.length > 0){
            const totales = descuentos.reduce((acc, item) => {
                if (item.descuento === 'VENTA') {
                    acc.venta += item.cantidad;
                } else if (item.descuento === 'MORTALIDAD') {
                    acc.mortalidad += item.cantidad;
                } else if (item.descuento === 'TRASLADO') {
                    acc.traslado += item.cantidad;
                }else if (item.descuento === 'DESCUENTO') {
                    acc.descuento += item.cantidad;
                }
                return acc;
            },
                { venta: 0, mortalidad: 0, traslado: 0, descuento: 0 }
            );
            setTotales(totales);
        }
    }, [descuentos]);



    return { consumido, totales };


};